import { render, staticRenderFns } from "./ValidCommande.vue?vue&type=template&id=ec3983b6&"
import script from "./ValidCommande.vue?vue&type=script&lang=js&"
export * from "./ValidCommande.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports